export const SET_NFE_COLLECTION = 'NFE/SET_NFE_COLLECTION';
export const SET_PRE_VALIDATION_NFE = 'NFE/SET_PRE_VALIDATION_NFE';
